import { createBrowserRouter, RouterProvider, RouteObject, useNavigate } from 'react-router-dom';
import './App.css';
import 'primeicons/primeicons.css';
import Footer from './components/footer/Footer';
import Header from './components/header/Header';
import MessageBox from './components/messagebox/MessageBox';
import ChartPage from './pages/type1/ChartPage';
import NotFound from './pages/notfound/NotFound';
import { HeadersRoutes } from './components/header/HeaderOptions';
import Home from './pages/home/Home';
import Login from './components/login/Login';
import GlobalContext, { useGlobalContext } from './context/GlobalContext';
import { useEffect, useState } from 'react';
import ThemeProvider from './components/theme/ThemeProvider';
import { API } from './services/api/API';
import Tooltip from './components/tooltip/Tooltip';
import DashBoard from './pages/dashboard/DashBoard';

const route = createBrowserRouter([

  {
    path: '*',
    element: <NotFound />
  },
  {
    path: '/menu',
    element: <Home />
  },
  {
    path: '/',
    element: <DashBoard />
  },
  ...HeadersRoutes.GetRoutes().Select(s => ({
    path: s.URL,
    element: <ChartPage />
  } as RouteObject))
])


interface IAPIStatus{
  Online: boolean
}

function App() {


  let [apiStatus, setApiStatus] = useState<IAPIStatus | undefined>(undefined);

  useEffect(()=>{

    (async() => {      
      
      try{
        let apiStatusResponse = await API.RequestAsync('/status/ping', '', 'GET');
        setApiStatus({
          Online: apiStatusResponse.ok
        });
      }catch(ex){
        
        console.log(ex);
        setApiStatus({
          Online: false
        });
      }
    })();
    

  }, []);


  return (
    <GlobalContext>
      <ThemeProvider>
       
        <Login />
        <MessageBox />
        <Header />
        {
        apiStatus && apiStatus.Online && <RouterProvider router={route} />
        }
        {
        apiStatus && !apiStatus.Online && (
            <div className='APIStatus'>
              <h1 className='H1APIStatus'>Erro na conexão</h1>
              <h4>Não foi possível estabelecer conexão com servidores</h4>
            </div>)
        }
        {
        !apiStatus && (
            <div className='APIStatus'>
              <h1 className='H1APIStatus'>Estabelecendo conexão</h1>
              <h4>Aguarde...</h4>
            </div>)
        }
        <Footer />
      </ThemeProvider>
    </GlobalContext>

  );
}

export default App;
